module.exports = __webpack_public_path__ + "static/privacy-3-32c73af6008752ad24425c3a4d711be0.svg";